/**
 * Created by strunz on 23.05.2017.
 */


import {Pipe} from '@angular/core';

@Pipe({
    name: 'durationUnit'
})
export class DurationUnitPipe {
    transform(durationUnit: string,duration: number): string {
        if(duration===1 && durationUnit.toUpperCase() !== 'SEMESTER'){
            return durationUnit.substring(0,durationUnit.length-1);
        }else{
            return durationUnit;
        }
    }
}